import {ReactNode} from "react";
import {DibJsonNode} from "../types";
import classes from "./ExternalLinkLEGACY.module.css";

export const ExternalLinkLEGACY = ({
    node,
    children,
}: {
    node: DibJsonNode;
    children: ReactNode[];
}) => {
    // Noen eksterne lenker har ikke object i det hele tatt (topic: 47fa71d5-e904-4500-89cd-9649cbbc82a9)
    // I disse tilfellene respekterer vi element.attritubes.href.
    const hasObject = !!node.object;
    const href = !hasObject
        ? node.element?.attributes?.href || "#"
        : node.object?.type === "linkdata"
          ? node.object.data.href
          : "#";

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.externalLink}
        >
            {children}
        </a>
    );
};
